var map = {
	"./bl-comment.svg": 94818,
	"./bl-down.svg": 80236,
	"./bl-pay.svg": 36071,
	"./bl-recive.svg": 41387,
	"./bl-send.svg": 82696,
	"./gray-comment.svg": 22609,
	"./gray-down.svg": 12039,
	"./gray-pay.svg": 22452,
	"./gray-recive.svg": 35834,
	"./gray-send.svg": 62134,
	"./success.svg": 23839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42130;